<template>
  <div class='relative-position configuring-wrap'>
    <div :class='[isContinue && !item.clientId ? "blur-loader" : "blur-loader--unblured"]'>
      <v-row>
        <v-col>
          <v-expansion-panels v-model='expandPanel' multiple>
            <v-expansion-panel>
              <v-expansion-panel-header class="main-padding">
                <div class='flex justify-start align-center'>
                  <span class='subtitle-1 font-weight-bold'>Instruction</span>
                  <v-icon
                    color='#8074c2'
                    class='ml-2'
                  >
                    mdi-information
                  </v-icon>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-html='systemInstruction'></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          xs='12'
          sm='6'
        >
          <div
            class='warehouseCard'
          >
            <v-row>
              <v-col cols='1'>
                <div class='warehouseCard__icon-block'>
                  <img class='warehouseCard__icon' src='@/assets/icons/svg/warehouse.svg'>
                </div>
              </v-col>
              <v-col cols='11'>
                <div>
                  <p
                    style='font-size: 1rem; color: #000000;'
                    class='mb-0'
                  >
                    <b>{{warehouseInfo.name}}</b>
                  </p>
                </div>
                <div>
                  <p style='font-size: 0.9rem' class='mb-0'>{{warehouseInfo.description}}</p>
                </div>
                <v-divider class='mt-2' />
                <v-row class='mt-2 mb-0 flex justify-end' style='max-height: 45px' v-if='warehouseInfo.info'>
                  <v-col cols='auto' style='max-height: 45px; box-sizing: border-box' class='py-0 flex'>
                    <p style='display: block;' class='mb-0 text-uppercase text-grey-6 text-center'>folders: </p>
                    <p style='display: block;' class='mb-0 ml-1 text-uppercase text-center'><b>{{warehouseInfo.info.countCategories}}</b></p>
                  </v-col>
                  <v-col cols='auto' style='max-height: 45px; box-sizing: border-box' class='py-0 flex'>
                    <p style='display: block;' class='mb-0 text-uppercase text-grey-6 text-center'>items: </p>
                    <p style='display: block;' class='mb-0 ml-1 text-uppercase text-center'><b>{{warehouseInfo.info.countItems}}</b></p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <v-row class='mt-4 mx-1'>
            <v-col>
              <h6 class='font-weight-bold'>KEYS</h6>
              <p class='text-grey-7'>You can get these keys on the QuickBooks side during the sync with Britecheck</p>
            </v-col>
          </v-row>
          <v-row class='mt-4 mx-1'>
            <v-col>
              <v-btn
                class="btn-main"
                color='#7972c0'
                depressed
                :href='authInSystemLink'
                target='_blank'
              >
                <span>
                  Get Keys
                </span>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class='mt-2 mx-1'>
            <v-col>
              <img
                class="image-icon left"
                src="@/assets/icons/svg/pencil2.svg"
              />
              <span class="label-text">Client ID</span>
              <div class="input-mb input-box d-flex flex-nowrap">
                <v-text-field
                  dense
                  placeholder="Enter Name clientID..."
                  v-model="item.clientId"
                  :rules="clientIdRules"
                  color="#43425d"
                  maxlength="128"
                  class="r-field item-name-field"
                  autocomplete='off'
                />
              </div>
            </v-col>
          </v-row>
          <v-row class='mt-2 mx-1'>
            <v-col>
              <img
                class="image-icon left"
                src="@/assets/icons/svg/pencil2.svg"
              />
              <span class="label-text">Client secret</span>
              <div class="input-mb input-box d-flex flex-nowrap">
                <v-text-field
                  dense
                  placeholder="Enter Name clientSecret..."
                  v-model="item.clientSecret"
                  :rules="clientIdRules"
                  color="#43425d"
                  maxlength="128"
                  class="r-field item-name-field"
                  autocomplete='off'
                />
              </div>
            </v-col>
          </v-row>
          <v-row class='mt-2 mx-1'>
            <v-col>
              <span class="label-text text-uppercase">automatic sync</span>
              <v-checkbox
                v-model='item.automaticSync'
                label="Automatic sync every hour"
                color="#8074c2"
                class='mt-1'
              />
            </v-col>
          </v-row>
          <v-row class='mt-2 mx-1' v-if='extendedFields'>
            <v-col>
              <v-select
                v-for='(item, index) in extendedFields'
                :key='index'
                :label='item.name'
                :items='item.items'
                :value='item.value ? item.value : ""'
                item-text='name'
                item-value='id'
                @change='v => { $emit("changeSelect", {name: item.name, id: v}) }'
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          xs='12'
          sm='6'
        >
          <div
            class='warehouseCard'
          >
            <v-row>
              <v-col cols='auto'>
                <v-img
                  :lazy-src='$publicPath + "/static/src/images/integration-logos/integration_qbo.svg"'
                  :src='$publicPath + "/static/src/images/integration-logos/integration_qbo.svg"'
                  max-width='130'
                  max-height='130'
                />
              </v-col>
              <v-col>
                <p class='text-grey-7'>Online accounting software. It allows users to create, <br />store and send invoices from any device.</p>
              </v-col>
            </v-row>
            <v-row class='mt-2 mb-0 flex justify-start' style='max-height: 45px'>
              <div>
                <p style='font-size: 0.9rem' class='mb-0'>{{systemInfo.name}}</p>
              </div>
            </v-row>
            <v-divider class='mt-2' />
            <v-row class='mt-2 mb-0 flex justify-end' style='max-height: 45px'>
              <v-col cols='auto' style='max-height: 45px; box-sizing: border-box' class='py-0 flex'>
                <p style='display: block;' class='mb-0 text-uppercase text-grey-6 text-center'>folders: </p>
                <p style='display: block;' class='mb-0 ml-1 text-uppercase text-center'><b>{{systemInfo.countCategories}}</b></p>
              </v-col>
              <v-col cols='auto' style='max-height: 45px; box-sizing: border-box' class='py-0 flex'>
                <p style='display: block;' class='mb-0 text-uppercase text-grey-6 text-center'>items: </p>
                <p style='display: block;' class='mb-0 ml-1 text-uppercase text-center'><b>{{systemInfo.countItems}}</b></p>
              </v-col>
            </v-row>
          </div>
          <v-row class='mx-1 mt-4'>
            <v-col>
              <h6 class='font-weight-bold'>Redirect</h6>
              <p class='text-grey-7'>Provide these URL to QuickBooks during the sync step with Britecheck</p>
            </v-col>
          </v-row>
          <v-row class='mx-1'>
            <v-col>
              <span class="label-text">Redirect URI</span>
              <div class="input-mb input-copy d-flex flex-nowrap">
                <v-text-field
                  dense
                  placeholder="Enter Name clientSecret..."
                  v-model="item.redirectUri"
                  color="#43425d"
                  maxlength="128"
                  :class="[
                    'r-field',
                     'item-name-field',
                     isCopied('redirectUri') ? 'isCopied' : ''
                     ]"
                  append-icon='mdi-checkbox-multiple-blank-outline'
                  filled
                  readonly
                  @click:append='copyToClipboard(item.redirectUri, "redirectUri")'
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class='mt-4' />
      <v-row class='mt-4'>
        <v-col class='my-auto flex justify-center'>
          <div class='relative-position' v-if='!isContinue'>
            <transition name="slide-fade">
              <v-btn
                class="btn-border"
                v-if='!tested'
                key='test'
                color='#7972c0'
                :disabled='loading'
                :loading='loading'
                @click='doTestConnection'
                depressed
              >
                <span class='ml-2'>
                  Create integration
                </span>
              </v-btn>
              <v-btn
              class="btn-border"
                v-else-if='tested && confirmLink'
                key='link'
                color='#7972c0'
                :href='confirmLink'
                target='_self'
                depressed
              >
                <span class='ml-2'>
                  CONFIRM CONNECTION
                </span>
              </v-btn>
              <p class='text-green-7 mt-4' v-else>The test connection was successful!</p>
            </transition>
          </div>
          <div class='position-relative' v-else>
            <v-btn
              class="btn-border"
              key='test'
              color='#7972c0'
              :disabled='loading || loaded'
              :loading='loading'
              @click='doTestConnection'
              depressed
            >
              <span class='ml-2'>
                TEST CONNECTION
              </span>
            </v-btn>
            <p class='text-green-7 mt-4' v-if='loaded'>The test connection was successful!</p>
          </div>
        </v-col>
      </v-row>
    </div>
    <transition name='fade'>
      <div v-if='isContinue && !item.clientId' class='blur-loader_content'>
        <CustomCircleProgressBar />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import service from '@/services/integrations'
import CustomCircleProgressBar from '@/components/CustomCircleProgressBar'
export default {
  name: 'syncStep2',
  props: {
    warehouse: {
      required: true
    },
    systemInfo: {
      required: true,
      type: [Boolean, Object]
    },
    loading: {
      type: Boolean,
      required: false
    },
    loaded: {
      type: Boolean,
      required: true
    },
    tested: {
      type: Boolean,
      required: true
    },
    isContinue: {
      type: Boolean,
      required: true
    },
    confirmLink: {
      type: String,
      required: true
    },
    extendedFields: {
      required: true
    }
  },
  data: () => ({
    item: {
      clientId: '',
      clientSecret: '',
      redirectUri: '',
      automaticSync: false
    },
    systemDescription: '',
    systemInstruction: '',
    authInSystemLink: '',
    copied: '',
    clientIdRules: [
      v => !!v.length || 'This field shouldn\'t be empty'
    ],
    expandPanel: []
  }),
  computed: {
    ...mapGetters('warehouses', {
      warehousesList: 'getWarehousesList'
    }),
    ...mapGetters('integrations', {
      integrationInfo: 'getIntegrationInfo'
    }),
    letSetConnection() {
      const itemsToCheck = ['clientId', 'clientSecret', 'redirectUri']
      const filledLength = itemsToCheck.reduce((sum, current) => {
        if (this.item[current].length) sum++
        return sum
      }, 0)
      return filledLength === itemsToCheck.length
    },
    isCopied() {
      const vm = this
      return v => vm.copied === v
    },
    warehouseInfo() {
      if (this.warehouse.id && this.warehousesList.length) return this.warehousesList.find(item => item.id === this.warehouse.id)
      return {}
    }
  },
  methods: {
    copyToClipboard(str, copiedFrom) {
      navigator.clipboard.writeText(str).then(() => {
        this.copied = copiedFrom
        setTimeout(() => {
          this.copied = ''
        }, 1500)
      })
    },
    doTestConnection() {
      const payload = {
        inventoryId: this.warehouse.id,
        clientId: this.item.clientId,
        clientSecret: this.item.clientSecret,
        syncMode: this.item.automaticSync ? 'AUTO' : 'MANUAL'
      }
      this.$emit('testConnection', payload)
    },
    setConnection() {
      this.$emit('setConnection', {
        clientId: this.item.clientId,
        clientSecret: this.item.clientSecret,
        syncMode: this.item.automaticSync ? 'AUTO' : 'MANUAL'
      })
    }
  },
  async created() {
    this.$store.dispatch('warehouses/loadWarehousesList')
    const response = await service.getInfo({
      system: 'qbo',
      data: {
        inventoryId: this.warehouse.id
      }
    })
    if (response?.data?.error?.type === 200) {
      this.integrationInfo.id = response.data.data.id
      this.integrationInfo.name = response.data.data.name
      this.integrationInfo.alias = response.data.data.alias
      this.integrationInfo.description = response.data.data.description
      this.$store.commit('integrations/setIntegrationInfo', this.integrationInfo)

      this.item.redirectUri = response.data.data.redirectURI
      this.authInSystemLink = response.data.data.link
      this.systemDescription = response.data.data.description
      this.systemInstruction = response.data.data.instruction
      if (this.isContinue) {
        this.item = {}
        for (const [key, value] of Object.entries(response.data.data.settings)) {
          if (key !== 'syncMode') {
            this.item[key] = value
          } else {
            this.item.automaticSync = value === 'AUTO'
          }
        }
      }
      if (response.data.data.settings) {
        const payload = {}
        for (const [key, val] of Object.entries(response.data.data.settings)) {
          this.item[key] = val
          payload[key] = val
        }
        if (response.data.data.extendedFields) {
          payload.accounts = response.data.data.extendedFields
          payload.extendedFields = Object.values(response.data.data.extendedFields)
            .reduce((obj, current) => {
              if (current.value) {
                obj[current.name] = current.value
              }
              return obj
            }, {})
        }
        this.item.redirectUri = response.data.data.redirectURI
        this.$emit('presetData', payload)
      }
    }
    if (!this.isContinue) this.expandPanel.push(0)
  },
  components: {
    CustomCircleProgressBar
  }
}
</script>

<style src='@/styles/base/integrations.scss' scoped lang='scss'></style>
<style lang='scss' scoped>
  .image-icon {
    display: none;
  }
  .slide-fade-enter-active {
    transition: all .5s ease-in
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0)
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(-15px);
    opacity: 0;
    position: absolute;
  }
  .isCopied ::v-deep .v-input__slot {
    animation: copied 1.5s linear
  }
  @keyframes copied {
    0% {
      background-color: rgba(#8074c2, 0.6);
    }
    25% {
      background-color: rgba(#8074c2, 0.45);
    }
    50% {
      background-color: rgba(#8074c2, 0.30);
    }
    75% {
      background-color: rgba(#8074c2, 0.15);
    }
    100% {
      background-color: rgba(0, 0, 0, 0.06)
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .blur-loader {
    filter: blur(2.5px);
    transition: 0.2s linear;
    &--unblured {
      transition: 0.5s linear;
    }
    &_content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      background-color: rgba(#fff, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
